module.exports = __webpack_public_path__ + "media/images/menu/reticulum-d58ca543c1a3de19f9accf3b0f76b313.jpg";